import { render, staticRenderFns } from "./announcementDetail.vue?vue&type=template&id=b8742012&scoped=true"
import script from "./announcementDetail.vue?vue&type=script&lang=js"
export * from "./announcementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8742012",
  null
  
)

export default component.exports